// "use client";

// import * as React from "react";
// import * as AlertDialogPrimitive from "@radix-ui/react-alert-dialog";
// import { cn } from "./utils";
// import { buttonVariants } from "./button";

// function AlertDialog(props) {
//   return <AlertDialogPrimitive.Root data-slot="alert-dialog" {...props} />;
// }

// function AlertDialogTrigger(props) {
//   return (
//     <AlertDialogPrimitive.Trigger data-slot="alert-dialog-trigger" {...props} />
//   );
// }

// function AlertDialogPortal(props) {
//   return (
//     <AlertDialogPrimitive.Portal data-slot="alert-dialog-portal" {...props} />
    
//   );
// }

// function AlertDialogOverlay({ className, ...props }) {
//   return (
//     <AlertDialogPrimitive.Overlay
//       data-slot="alert-dialog-overlay"
//       className={cn(
//         "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-black/50",
//         className
//       )}
//       {...props}
//     />
//   );
// }

// function AlertDialogContent({ className, ...props }) {
//   return (
//     <AlertDialogPortal>
//       <AlertDialogOverlay />
//       <AlertDialogPrimitive.Content
//         data-slot="alert-dialog-content"
//         className={cn(
//           "bg-background data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-4 rounded-lg border p-6 shadow-lg duration-200 sm:max-w-lg",
//           className
//         )}
//         {...props}
//         style={{
//           backgroundColor: "#dcdcdc",
//           border: "2px solid grey",
//           borderLeft:"5px solid red",
//           width:"100%",
//           height:"25vh",
//           padding:"0",
//         }}
//       />
//     </AlertDialogPortal>
//   );
// }

// function AlertDialogHeader({ className, ...props }) {
//   return (
//     <div
//       data-slot="alert-dialog-header"
//       className={cn("flex flex-col gap-2 text-center sm:text-left", className)}
//       {...props}
//       style={{
//         boxShadow: "1px 1px 3px grey",
//         backgroundColor: "white",
//         color: "Black",
//         borderRadius: "10px  10px 10px 10px ",
//         display:"flex",
//         height:"100%",
//         justifyContent:"center",
//         paddingLeft: "5px",
//         padding: "1vh",
//         margin:"5px"
//       }}
//     />
//   );
// }

// function AlertDialogFooter({ className, ...props }) {
//   return (
//     <div
//       data-slot="alert-dialog-footer"
//       className={cn(
//         "flex flex-col-reverse gap-2 sm:flex-row sm:justify-center",
//         className
//       )}
//       {...props}
//       style={{marginBottom:"5%",display:"flex",justifyContent:"center",alignItems:"center",height:"100%",width:"100%"}}
//     />
//   );
// }

// function AlertDialogTitle({ className, ...props }) {
//   return (
//     <AlertDialogPrimitive.Title
//       data-slot="alert-dialog-title"
//       className={cn("text-3xl font-bold", className)}
//       {...props}
//       style={{textAlign:"left"}}
//     />
//   );
// }

// function AlertDialogDescription({ className, ...props }) {
//   return (
//     <AlertDialogPrimitive.Description
//       data-slot="alert-dialog-description"
//       className={cn("text-muted-foreground text-md", className)}
//       {...props}
//       style={{textAlign:"left"}}
//     />
//   );
// }

// function AlertDialogAction({ className, ...props }) {
//   return (
//     <AlertDialogPrimitive.Action
//       className={cn(buttonVariants(), className)}
//       {...props}
//       style={{width:"35%",height:"70%" }}
//     />
//   );
// }

// function AlertDialogCancel({ className, ...props }) {
//   return (
//     <AlertDialogPrimitive.Cancel
//       className={cn(buttonVariants({ variant: "outline" }), className)}
//       {...props}
//       style={{width:"35%",height:"70%" }}
//     />
//   );
// }

// export {
//   AlertDialog,
//   AlertDialogPortal,
//   AlertDialogOverlay,
//   AlertDialogTrigger,
//   AlertDialogContent,
//   AlertDialogHeader,
//   AlertDialogFooter,
//   AlertDialogTitle,
//   AlertDialogDescription,
//   AlertDialogAction,
//   AlertDialogCancel,
// };


"use client";

import * as React from "react";
import * as AlertDialogPrimitive from "@radix-ui/react-alert-dialog";
import { cn } from "./utils";
import { buttonVariants } from "./button";
import { X, AlertTriangle, Info, CheckCircle, HelpCircle } from "lucide-react";

// Variants for different dialog types
const dialogVariants = {
  default: {
    borderColor: "border-gray-200",
    icon: Info,
    iconColor: "text-blue-600",
    headerBg: "bg-white",
  },
  destructive: {
    borderColor: "border-red-200",
    icon: AlertTriangle,
    iconColor: "text-red-600",
    headerBg: "bg-red-50",
  },
  success: {
    borderColor: "border-green-200",
    icon: CheckCircle,
    iconColor: "text-green-600",
    headerBg: "bg-green-50",
  },
  warning: {
    borderColor: "border-orange-200",
    icon: AlertTriangle,
    iconColor: "text-orange-600",
    headerBg: "bg-orange-50",
  },
};

function AlertDialog({ variant = "default", ...props }) {
  return <AlertDialogPrimitive.Root data-slot="alert-dialog" {...props} />;
}

function AlertDialogTrigger(props) {
  return (
    <AlertDialogPrimitive.Trigger data-slot="alert-dialog-trigger" {...props} />
  );
}

function AlertDialogPortal(props) {
  return (
    <AlertDialogPrimitive.Portal data-slot="alert-dialog-portal" {...props} />
  );
}

function AlertDialogOverlay({ className, ...props }) {
  return (
    <AlertDialogPrimitive.Overlay
      data-slot="alert-dialog-overlay"
      className={cn(
        "data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 fixed inset-0 z-50 bg-gray-800/70 backdrop-blur-sm",
        className
      )}
      style={{
        backgroundColor: 'rgba(75, 85, 99, 0.7)',
        backdropFilter: 'blur(4px)',
      }}
      {...props}
    />
  );
}

function AlertDialogContent({ 
  className, 
  variant = "default", 
  showIcon = true,
  ...props 
}) {
  const variantStyle = dialogVariants[variant];
  const IconComponent = variantStyle.icon;

  return (
    <AlertDialogPortal>
      <AlertDialogOverlay />
      <AlertDialogPrimitive.Content
        data-slot="alert-dialog-content"
        className={cn(
          "bg-white data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 fixed top-[50%] left-[50%] z-50 grid w-full max-w-[calc(100%-2rem)] translate-x-[-50%] translate-y-[-50%] gap-0 rounded-xl border shadow-2xl duration-200 sm:max-w-lg",
          variantStyle.borderColor,
          className
        )}
        {...props}
        style={{
          backgroundColor: "white",
          border: "1px solid #e5e7eb",
          boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
          width: "90%",
          maxWidth: "400px",
          padding: "0",
          height:"auto",
          maxHeight:"70vh",
          overflow: "hidden",
          zIndex:"10000"
        }}
      >
        {showIcon && (
          <div className={cn(
            "flex items-center justify-center p-4 border-b border-gray-100",
            variantStyle.headerBg
          )}>
            <div className={cn(
              "p-3 rounded-full",
              variant === "destructive" ? "bg-red-100" :
              variant === "success" ? "bg-green-100" :
              variant === "warning" ? "bg-orange-100" : "bg-blue-100"
            )}>
              <IconComponent className={cn("w-6 h-6", variantStyle.iconColor)} />
            </div>
          </div>
        )}
        {props.children}
      </AlertDialogPrimitive.Content>
    </AlertDialogPortal>
  );
}

function AlertDialogHeader({ className, variant = "default", ...props }) {
  const variantStyle = dialogVariants[variant];
  
  return (
    <div
      data-slot="alert-dialog-header"
      className={cn(
        "flex flex-col gap-3 px-6 py-5",
        variantStyle.headerBg,
        className
      )}
      style={{
        backgroundColor: "white",
        color: "#1f2937",
        padding: "1.5rem 1.5rem 1rem 1.5rem",
        minHeight: "auto",
        display:"flex",
        justifyContent:"center",
        alignItems:"center"
      }}
      {...props}
    />
  );
}

function AlertDialogFooter({ className, ...props }) {
  return (
    <div
      data-slot="alert-dialog-footer"
      className={cn(
        "flex flex-row justify-center gap-3 py-2 bg-gray-50 border-t border-gray-100",
        className
      )}
      style={{
        padding: "2rem 1.5rem",
        minHeight: "50px",
      }}
      {...props}
    />
  );
}

function AlertDialogTitle({ className, ...props }) {
  return (
    <AlertDialogPrimitive.Title
      data-slot="alert-dialog-title"
      className={cn("text-lg font-semibold text-gray-900 leading-6", className)}
      style={{
        fontSize: "1.425rem",
        fontWeight: 700,
        lineHeight: "1.5rem",
        color: "#111827",
      }}
      {...props}
    />
  );
}

function AlertDialogDescription({ className, ...props }) {
  return (
    <AlertDialogPrimitive.Description
      data-slot="alert-dialog-description"
      className={cn("text-sm text-gray-600 leading-5", className)}
      style={{
        fontSize: "0.875rem",
        lineHeight: "1.25rem",
        color: "#6b7280",
      }}
      {...props}
    />
  );
}

function AlertDialogAction({ className, variant = "default", ...props }) {
  const getButtonStyle = () => {
    switch (variant) {
      case "destructive":
        return "bg-red-600 hover:bg-red-700 text-white focus:ring-red-500";
      case "success":
        return "bg-green-600 hover:bg-green-700 text-white focus:ring-green-500";
      case "warning":
        return "bg-orange-600 hover:bg-orange-700 text-white focus:ring-orange-500";
      default:
        return "bg-blue-600 hover:bg-blue-700 text-white focus:ring-blue-500";
    }
  };

  return (
    <AlertDialogPrimitive.Action
      className={cn(
        buttonVariants(),
        "inline-flex justify-center rounded-lg px-4 py-2 text-sm font-medium transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none",
        getButtonStyle(),
        className
      )}
      style={{
        height: "40px",
        minWidth: "80px",
        padding: "0.5rem 1rem",
        fontSize: "0.875rem",
        fontWeight: 500,
         marginBottom:"1rem"
      }}
      {...props}
    />
  );
}

function AlertDialogCancel({ className, ...props }) {
  return (
    <AlertDialogPrimitive.Cancel
      className={cn(
        buttonVariants({ variant: "outline" }),
        "inline-flex justify-center rounded-lg border border-gray-300 bg-white px-4 py-2 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:ring-offset-2 disabled:opacity-50 disabled:pointer-events-none",
        className
      )}
      style={{
        height: "40px",
        minWidth: "80px",
        padding: "0.5rem 1rem",
        fontSize: "0.875rem",
        fontWeight: 500,
        border: "1px solid #d1d5db",
        marginBottom:"1rem"
      }}
      {...props}
    />
  );
}

// Usage example with consistent button positioning:
function ExampleUsage() {
  return (
    <div className="space-y-4">
      {/* Default Dialog */}
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <button className="px-4 py-2 bg-blue-500 text-white rounded">Open Default Dialog</button>
        </AlertDialogTrigger>
        <AlertDialogContent variant="default" showIcon={true}>
          <AlertDialogHeader variant="default">
            <AlertDialogTitle>Default Dialog</AlertDialogTitle>
            <AlertDialogDescription>
              This is a default dialog with consistent button positioning.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction>Continue</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Destructive Dialog */}
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <button className="px-4 py-2 bg-red-500 text-white rounded">Open Destructive Dialog</button>
        </AlertDialogTrigger>
        <AlertDialogContent variant="destructive" showIcon={true}>
          <AlertDialogHeader variant="destructive">
            <AlertDialogTitle>Delete Account</AlertDialogTitle>
            <AlertDialogDescription>
              Are you sure you want to delete your account? This action cannot be undone.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogCancel>Cancel</AlertDialogCancel>
            <AlertDialogAction variant="destructive">Delete</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Success Dialog - Single Button */}
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <button className="px-4 py-2 bg-green-500 text-white rounded">Open Success Dialog</button>
        </AlertDialogTrigger>
        <AlertDialogContent variant="success" showIcon={true}>
          <AlertDialogHeader variant="success">
            <AlertDialogTitle>Success!</AlertDialogTitle>
            <AlertDialogDescription>
              Your changes have been saved successfully.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogAction variant="success">Okay</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>

      {/* Warning Dialog - Single Button */}
      <AlertDialog>
        <AlertDialogTrigger asChild>
          <button className="px-4 py-2 bg-orange-500 text-white rounded">Open Warning Dialog</button>
        </AlertDialogTrigger>
        <AlertDialogContent variant="warning" showIcon={true}>
          <AlertDialogHeader variant="warning">
            <AlertDialogTitle>Warning</AlertDialogTitle>
            <AlertDialogDescription>
              This action may have unintended consequences. Please proceed with caution.
            </AlertDialogDescription>
          </AlertDialogHeader>
          <AlertDialogFooter>
            <AlertDialogAction variant="warning">Proceed</AlertDialogAction>
          </AlertDialogFooter>
        </AlertDialogContent>
      </AlertDialog>
    </div>
  );
}

export {
  AlertDialog,
  AlertDialogPortal,
  AlertDialogOverlay,
  AlertDialogTrigger,
  AlertDialogContent,
  AlertDialogHeader,
  AlertDialogFooter,
  AlertDialogTitle,
  AlertDialogDescription,
  AlertDialogAction,
  AlertDialogCancel,
  dialogVariants,
  ExampleUsage
};